import { StepType, type Experience } from '../../../../../types/CoreShoppingExperience';
import convertProductToItem from './convertProductToItem';
import convertPartialProductToItem from './convertPartialProductToItem';

const convertToViewItemListEvent = (experience: Experience, partialExperience?: Experience) => {
  const items = experience.purchasableTrips
    .flatMap((trip) => trip.steps)
    .filter((step) => step.stepType === StepType.SEGMENT)
    .flatMap((step) => step.products)
    .flatMap((product) =>
      product.variants.map((variant) => {
        return { product, variant };
      }),
    );

  const partialItems =
    partialExperience?.purchasableTrips
      .flatMap((trip) => trip.steps)
      .flatMap((step) => step.products)
      .flatMap((product) =>
        product.variants.map((variant) => {
          return { product, variant };
        }),
      )
      .map((item, index) => {
        return { ...item, index };
      }) ?? [];

  const ineligibleitems = partialItems.filter(
    (partialItem) =>
      !items.some(
        (item) =>
          partialItem?.variant?.encryptedId &&
          item?.variant?.encryptedId &&
          partialItem.variant.encryptedId === item.variant.encryptedId &&
          item.variant.purchaseOptions.length > 0,
      ),
  );

  return {
    items: items.flatMap((item, itemIndex) => convertProductToItem(item.variant, item.product, itemIndex)),

    ineligibleItems: ineligibleitems.map((item) => convertPartialProductToItem(item.variant, item.index)),
  };
};

export default convertToViewItemListEvent;
